// Project imports
import config from "./config.js";

/**
 * @description Utility class for common client-side functions
 * @export
 * @class Utils
 */
export default class Utils {
  /**
   * @description Converts a number to a currency string
   * @static
   * @param {value} value:  The number to convert to currency
   * @param {string} locale: The BCP 47 language tag (e.g., 'en-ca', 'fr-ca') - matches Intl.NumberFormat locales parameter
   * @return {string}       The currency formatted string
   * @memberof Utils
   */
  static currency(value, locale) {
    value = Math.round(value * 100) / 100;
    return new Intl.NumberFormat(locale, { style: "currency", currency: "CAD" }).format(value);
  }

  static langFromUrl() {
    if (window.location.pathname.startsWith("/fr")) {
      return "fr-ca";
    }
    return "en-ca";
  }

  /**
   * @description Retrieves the invoice data from the API
   * @static
   * @param {string} invoiceNumber: The invoice number to retrieve
   * @param {string} orderId:        The orderId to retrieve the invoice
   * @return {object}               The invoice data
   * @memberof Utils
   */
  static async getInvoice(invoiceNumber, orderId) {
    // Security by obscurity - API caller needs to know both the invoice and obfuscated orderId obtain the invoice
    const url = `${config.apiUrl}/invoices/${invoiceNumber}?orderId=${orderId}`;

    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await fetch(url, options);
    if (!res.ok) {
      throw new Error(`Failed to get invoice: ${res.status}`);
    }

    return await res.json();
  }
}
